import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import React, { useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar } from "react-multi-date-picker";
import BoxShadow from "../../../../../../Common/Components/BoxShadow";
import { ConvertDate, removeSepMoney, sepJustMoney } from "../../../../../../Common/Function/index";
function OptionAndDate({ setForm, form }) {

  const [ballPrices, setBallPrices] = useState({ ballPrice: "", buyballprice: "" });

  const [needballprice, setNeedballprice] = useState(false);
  const [needchild, setNeedchild] = useState(false);

  const switchs = [
    {
      label: "نیاز ثبت عنوان میباشد",
      key: "needtitle",
    },
    {
      label: "نیاز ثبت جنسیت میباشد",
      key: "needgender",
    },
    {
      label: "نیاز به ثبت ظرفیت میباشد",
      key: "needcapacity",
    },
    {
      label: "نیاز به ثبت حضور غیاب میباشد",
      key: "needsession",
    },
    {
      label: "نیاز به ثبت تاریخ میباشد",
      key: "needdate",
    },
    {
      label: "آیا مجموعه دارای امکان رزرو قراردادی اقساطی نیز میباشد؟",
      key: "needghest",
    },
    {
      label: "نیاز به ثبت خردسال می باشد ؟",
      key: "needchild",
    },
    {
      label: "توضیحات خردسال",
      key: "childDescription",
    },
    {
      label: "آیا اجاره توپ دارد ؟",
      key: "needballprice",
    },
    {
      label: "مبلغ  خرید توپ را وارد کنید",
      key: "buyballprice",
    },
    {
      label: "مبلغ اجاره توپ را وارد کنید",
      key: "ballPrice",
    }
  ];

  const handleChange = (key, el) => {

    let obj = {};
    if (key === "needdate") {
      obj = {
        ...form,
        option: {
          ...form.option,
          needsession: false,
          needghest: form.option.needdate === true ? false : true,
          needdate: !form.option.needdate,
        },
      };
    } else if (key === "needsession") {
      obj = {
        ...form,
        option: {
          ...form.option,
          needdate: false,
          needghest: false,
          needsession: !form.option.needsession,
        },
      };
    } else if (key === "needghest") {
      obj = {
        ...form,
        option: {
          ...form.option,
          needdate: true,
          needsession: false,
          needghest: !form.option.needghest,
        },
      };
    }
    else if (key === "needchild") {
      setNeedchild(!needchild);
      obj = {
        ...form,
        option: {
          ...form.option,
          [key]: !form.option[key],
        },
      };
    }
    else if (key === "childDescription") {
      obj = {
        ...form,
        child: el.target.value
      }
    }
    else if (key === "needballprice") {
      setNeedballprice(!needballprice)
      obj = {
        ...form,
        option: {
          ...form.option,
          [key]: !form.option[key],
        },
      };

    }
    else if (key === "ballPrice") {
      setBallPrices(prev => ({ ...prev, ballPrice: sepJustMoney(el.target.value) }));
      obj = {
        ...form,
        ballprice: removeSepMoney(el.target.value)
      }
    }
    else if (key === "buyballprice") {
      setBallPrices(prev => ({ ...prev, buyballprice: sepJustMoney(el.target.value) }));
      obj = {
        ...form,
        buyballprice: removeSepMoney(el.target.value)
      }
    }
    else {
      obj = {
        ...form,
        option: {
          ...form.option,
          [key]: !form.option[key],
        },
      };
    }
    setForm(obj);
  };
  return (
    <BoxShadow
      style={{
        marginTop: "20px",
      }}
    >
      <div className="row justify-content-around">
        <div className={`my-2 col-md-3`}>
          <h6 htmlFor="">تاریخ شروع و پایان قرارداد</h6>
          <Calendar
            range={true}
            onChange={data => {
              if (data.length > 1) {
                setForm({
                  ...form,
                  date_start: ConvertDate(
                    `${data[0].year}/${data[0].month.number}/${data[0].day}`
                  ),
                  date_end: ConvertDate(
                    `${data[1].year}/${data[1].month.number}/${data[1].day}`
                  ),
                });
              }
            }}
            calendar={persian}
            locale={persian_fa}
          />
        </div>

        <div className="col-md-3">
          <h6>امکانات زمان بندی</h6>
          <FormGroup>
            {switchs &&
              switchs.map((swich, key) => {
                if (swich.key == "ballPrice" || swich.key == "buyballprice") {
                  return (
                    needballprice &&
                    <div key={key}>
                      <label className="text-left mb-1"> {swich.label} </label>
                      <input type="text" className="form-control mb-2" value={ballPrices[swich.key]}
                        onChange={(el) => handleChange(swich.key, el)} />
                    </div>
                  )
                }
                else if (swich.key == "childDescription") {
                  return (
                    needchild &&
                    <div key={key}>
                      <label className="text-left mb-0"> {swich.label} </label>
                      <input type="text" className="form-control mb-3" placeholder="مثال: افراد زیر 150 سانت"
                        onChange={(el) => handleChange(swich.key, el)} />
                    </div>
                  )
                }
                else {
                  return (
                    <FormControlLabel
                      onChange={() => handleChange(swich.key)}
                      control={<Switch />}
                      label={swich.label}
                      checked={form.option[swich.key]}
                      key={key}
                    />
                  );
                }
              })}
          </FormGroup>
        </div>
      </div>
    </BoxShadow>
  );
}

export default OptionAndDate;
